import React, { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Spinner from 'components/Spinner';
import { getProjectById } from 'services/project-service';
import { isLegacyRevisionResultProject } from 'utils/shgcViewer';

const LegacyRevisionResult = lazy(() => import('./Revisions/RevisionResult'));
const RevisionResultV4Page = lazy(() => import('./Revisions/v4/RevisionResultV4Page'));

/**
 * Picks legacy vs V4 Revision Result from project.version.
 * v2 / missing → legacy; v3 / v4 → V4.
 */
const RevisionResultGate: React.FC = () => {
  const { projectId } = useParams();
  const { data, isLoading } = useQuery(
    ['GetProjectByID', projectId],
    async () => await getProjectById(projectId ?? ''),
    { enabled: !!projectId }
  );

  if (isLoading || !projectId) {
    return <Spinner />;
  }

  const useLegacy = isLegacyRevisionResultProject(data?.version);

  return (
    <Suspense fallback={<Spinner />}>
      {useLegacy ? (
        <div data-testid="revision-result-legacy">
          <LegacyRevisionResult />
        </div>
      ) : (
        <div data-testid="revision-result-v4">
          <RevisionResultV4Page />
        </div>
      )}
    </Suspense>
  );
};

export default RevisionResultGate;
